module.exports = __webpack_public_path__ + "img/photo2_7.0ad5f482.jpg";